module.exports = __webpack_public_path__ + "static/media/cafe_v_salon_1.6c467365.png";